export function getServiceTrackingUrl(): string {
  const productionDomains = ["fandom.com"];
  const baseUrl = productionDomains.find((domain) =>
    window.location.hostname.includes(domain),
  )
    ? "https://services.fandom.com/"
    : "https://services.fandom-dev." +
      (location.hostname.match(/(?!\.)(pl|us)$/) ?? ["us"])[0] +
      "/";

  return baseUrl.replace(/\/+$/, "");
}
